import { FileDescriptorRead, RasterUserSuppliedMeta } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";
import { ApiError } from "@nens/react-query-utils";

import {
  useInvalidateFileDescriptorViewAsQuery,
  useUpdateFileDescriptorQuery,
} from "@/features/project-file-preview";

export const useUpdateRasterMeta = (descriptor: FileDescriptorRead | undefined) => {
  const updateFileDescriptorQuery = useUpdateFileDescriptorQuery();
  const invalidateFileDescriptorViewAsQuery = useInvalidateFileDescriptorViewAsQuery();

  return useMutationWithErrorHandler<void, ApiError, RasterUserSuppliedMeta>(async (values) => {
    if (!descriptor) return;
    const { id } = descriptor;

    const response = await getRanaApiV1().FileDescriptorsApi.fileDescriptorUpdateMeta({
      fileDescriptorId: id,
      values,
    });

    updateFileDescriptorQuery(response.id, response);
    invalidateFileDescriptorViewAsQuery(id, "lizard-raster");
  }, {});
};
